module.exports = function() {
  return new Worker(__webpack_public_path__ + "a86980d3a2912f41d4db.worker.js");
};